"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ThemeService = require("../common/ThemeService");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var playerOld = 'avatar_border.png';
var seat = 'seat.png';
var backCard = 'bc1.png';
var dealer = '/dealer.png';
var foldPlayer = 'fold-player.png';
var cashout = 'cashout.png';
var baseUrl = "/images/handReplay/PartyPoker/";
var baseUrlForAll = "/images/handReplay/";
var Seat = /*#__PURE__*/function (_Component) {
  _inherits(Seat, _Component);
  var _super = _createSuper(Seat);
  function Seat(props) {
    var _this;
    _classCallCheck(this, Seat);
    _this = _super.call(this, props);
    _this.componentDidMount = function () {
      if (localStorage.getItem("loggedInType") === "Danskespil") {
        baseUrl = "/images/handReplay/Danskespil/";
      }
    };
    _this.getCurrencySymbol = function (currency) {
      console.log("getCurrencySymbol..........", currency);
      var currenciesList = [{
        key: 'USD',
        code: "$"
      }, {
        key: 'EUR',
        code: "\u20AC"
      }, {
        key: 'GBP',
        code: "\xA3"
      }, {
        key: 'CAD',
        code: "C".concat("$")
      }, {
        key: 'RUB',
        code: "\u20BD"
      }, {
        key: 'DKK',
        code: "K".concat("r").concat(".")
      }, {
        key: 'GEL',
        code: "\u20BE"
      }];
      var currencyObj = currenciesList.filter(function (obj) {
        return currency === obj.key;
      });
      if (currencyObj.length > 0) return currencyObj[0].code;else return "$";
    };
    _this.state = {
      lowEndChips: [0.50, 0.25, 0.10, 0.05, 0.01],
      highEndChips: [1000000000, 500000000, 100000000, 25000000, 5000000, 1000000, 500000, 100000, 25000, 5000, 1000, 500, 100, 25, 5, 1],
      coinsList: []
    };
    return _this;
  }
  _createClass(Seat, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps !== this.props) {
        if (nextProps.player.amount) {
          var coins = this.props.getCoins(nextProps.player.amount, this.state.highEndChips, this.state.lowEndChips);
          if (coins.length > 3) {
            this.setState({
              coinsList: [coins[0], coins[1], coins[2]]
            });
          } else {
            this.setState({
              coinsList: _toConsumableArray(coins)
            });
          }
        } else {
          this.setState({
            coinsList: []
          });
        }
      }
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var cardsList = this.props.player.cards ? this.props.player.cards.split(',').filter(function (data) {
        return data.trim() !== "";
      }) : [];
      var seatX = 0;
      var seatName = 0;
      var chipPosX = 0;
      var chipPosY = 0;
      var dealX = 0;
      var dealY = 0;
      var cashoutX = 0;
      var cashoutY = 0;
      if (this.props.player.seatPosition === "left") {
        seatX = parseInt(this.props.player.cx) - 9;
        seatName = seatX + 2;
        if (this.props.player.coinPosition === "top") {
          chipPosX = seatX + 13;
          chipPosY = parseInt(this.props.player.cy) + 12;
          dealX = parseInt(this.props.player.cx) + 2;
          dealY = parseInt(this.props.player.cy) + 9;
          cashoutX = parseInt(this.props.player.cx) - 12;
          cashoutY = parseInt(this.props.player.cy) + 3;
        } else if (this.props.player.coinPosition === "bottom") {
          chipPosX = seatX + 16;
          chipPosY = parseInt(this.props.player.cy) - 6;
          dealX = parseInt(this.props.player.cx) + 2;
          dealY = parseInt(this.props.player.cy) - 2;
          cashoutX = parseInt(this.props.player.cx) - 12;
          cashoutY = parseInt(this.props.player.cy) + 5;
        } else {
          chipPosX = seatX + 20;
          chipPosY = parseInt(this.props.player.cy) + 6;
          dealX = parseInt(this.props.player.cx) + 8;
          dealY = parseInt(this.props.player.cy) + 5;
          cashoutX = parseInt(this.props.player.cx) - 10;
          cashoutY = parseInt(this.props.player.cy) + 6;
        }
      } else {
        seatX = parseInt(this.props.player.cx) + 3;
        seatName = seatX + 5;
        if (this.props.player.coinPosition === "top") {
          chipPosX = seatX;
          chipPosY = parseInt(this.props.player.cy) + 12;
          dealX = parseInt(this.props.player.cx) - 2;
          dealY = parseInt(this.props.player.cy) + 9;
          cashoutX = parseInt(this.props.player.cx) + 15;
          cashoutY = parseInt(this.props.player.cy) + 5;
        } else if (this.props.player.coinPosition === "bottom") {
          chipPosX = seatX - 4;
          chipPosY = parseInt(this.props.player.cy) - 9;
          dealX = parseInt(this.props.player.cx) - 2;
          dealY = parseInt(this.props.player.cy) - 2;
          cashoutX = parseInt(this.props.player.cx) + 15;
          cashoutY = parseInt(this.props.player.cy) + 5;
        } else {
          chipPosX = seatX - 10;
          chipPosY = parseInt(this.props.player.cy) + 4;
          dealX = parseInt(this.props.player.cx) - 2;
          dealY = parseInt(this.props.player.cy) + 4;
          cashoutX = parseInt(this.props.player.cx) + 15;
          cashoutY = parseInt(this.props.player.cy) + 5;
        }
      }
      var rectWidth = this.props.player.amount ? this.props.player.amount.toString().length > 2 ? this.props.player.amount.toString().length * 1 : this.props.player.amount.toString().length * 0.8 + 1.5 : 0;
      return /*#__PURE__*/_react["default"].createElement("svg", null, this.props.player.amount > 0 ? /*#__PURE__*/_react["default"].createElement("svg", {
        width: "100%",
        height: "100%"
      }, /*#__PURE__*/_react["default"].createElement("rect", {
        id: "rectId",
        x: chipPosX + "%",
        y: parseInt(chipPosY) + 2.5 + "%",
        width: rectWidth + 2 + "%",
        height: "3%",
        fill: "black",
        fillOpacity: "0.4",
        rx: "10"
      }), /*#__PURE__*/_react["default"].createElement("text", {
        id: "textId",
        x: chipPosX + 1 + "%",
        y: parseInt(chipPosY) + 4.5 + "%",
        onChange: this.adjustRect,
        fill: "white"
      }, (this.props.gameTypeForTitle === "tournament" ? "" : this.getCurrencySymbol(this.props.currency)) + this.props.player.amount), " ") : null, this.props.player.seat === this.props.player.buttonSeat ? /*#__PURE__*/_react["default"].createElement("image", {
        x: dealX + "%",
        y: dealY + "%",
        width: "2.5%",
        height: "2.5%",
        href: (0, _ThemeService.getImage)(baseUrlForAll, dealer)
      }) : null, this.state.coinsList.length > 0 ? this.state.coinsList.map(function (coin, index) {
        return coin[index].map(function (value, i) {
          var afterDec = 0;
          if (parseInt(value) < 1) {
            afterDec = value.toString().split('.')[1];
          }
          return parseInt(value) > 0 ? /*#__PURE__*/_react["default"].createElement("image", {
            key: i,
            x: chipPosX + index * 2.5 + "%",
            y: parseInt(chipPosY) - i * 0.3 + "%",
            width: "2.5%",
            height: "2.5%",
            href: baseUrl + 'chips/chipD' + value + '.png'
          }) : /*#__PURE__*/_react["default"].createElement("image", {
            key: i,
            x: chipPosX + index * 2.5 + "%",
            y: parseInt(chipPosY) - i * 0.3 + "%",
            width: "2.5%",
            height: "2.5%",
            href: baseUrl + 'chips/chipC' + afterDec + '.png'
          });
        });
      }) : null, this.props.showCards ? this.props.cardsLength > 2 ? this.props.player.status === "active" ? this.props.player.cards ? /*#__PURE__*/_react["default"].createElement("svg", null, /*#__PURE__*/_react["default"].createElement("image", {
        x: seatX + 1 + "%",
        y: parseInt(this.props.player.cy - 4.7) + "%",
        width: "11%",
        height: "11%",
        href: baseUrl + 'cards/' + cardsList[0].replace(/^\s+/, "") + '.png'
      }), /*#__PURE__*/_react["default"].createElement("image", {
        x: seatX + 3.2 + "%",
        y: parseInt(this.props.player.cy - 4.7) + "%",
        width: "11%",
        height: "11%",
        href: baseUrl + 'cards/' + cardsList[1].replace(/^\s+/, "") + '.png'
      }), /*#__PURE__*/_react["default"].createElement("image", {
        x: seatX + 5.5 + "%",
        y: parseInt(this.props.player.cy - 4.7) + "%",
        width: "11%",
        height: "11%",
        href: baseUrl + 'cards/' + cardsList[2].replace(/^\s+/, "") + '.png'
      }), /*#__PURE__*/_react["default"].createElement("image", {
        x: seatX + 8.2 + "%",
        y: parseInt(this.props.player.cy - 4.7) + "%",
        width: "11%",
        height: "11%",
        href: baseUrl + 'cards/' + cardsList[3].replace(/^\s+/, "") + '.png'
      })) : /*#__PURE__*/_react["default"].createElement("svg", null, /*#__PURE__*/_react["default"].createElement("image", {
        x: seatX + 1 + "%",
        y: parseInt(this.props.player.cy - 4.5) + "%",
        width: "11%",
        height: "11%",
        href: baseUrl + backCard
      }), /*#__PURE__*/_react["default"].createElement("image", {
        x: seatX + 3.2 + "%",
        y: parseInt(this.props.player.cy - 4.5) + "%",
        width: "11%",
        height: "11%",
        href: baseUrl + backCard
      }), /*#__PURE__*/_react["default"].createElement("image", {
        x: seatX + 5.5 + "%",
        y: parseInt(this.props.player.cy - 4.5) + "%",
        width: "11%",
        height: "11%",
        href: baseUrl + backCard
      }), /*#__PURE__*/_react["default"].createElement("image", {
        x: seatX + 8.2 + "%",
        y: parseInt(this.props.player.cy - 4.5) + "%",
        width: "11%",
        height: "11%",
        href: baseUrl + backCard
      })) : null : this.props.player.status === "active" ? this.props.player.cards ? /*#__PURE__*/_react["default"].createElement("svg", null, /*#__PURE__*/_react["default"].createElement("image", {
        x: seatX + 1 + "%",
        y: parseInt(this.props.player.cy - 4.7) + "%",
        width: "11%",
        height: "11%",
        href: baseUrl + 'cards/' + cardsList[0].replace(/^\s+/, "") + '.png'
      }), /*#__PURE__*/_react["default"].createElement("image", {
        x: seatX + 6.2 + "%",
        y: parseInt(this.props.player.cy - 4.7) + "%",
        width: "11%",
        height: "11%",
        href: baseUrl + 'cards/' + cardsList[1].replace(/^\s+/, "") + '.png'
      })) : /*#__PURE__*/_react["default"].createElement("svg", null, /*#__PURE__*/_react["default"].createElement("image", {
        x: seatX + 1 + "%",
        y: parseInt(this.props.player.cy - 4.5) + "%",
        width: "11%",
        height: "11%",
        href: baseUrl + backCard
      }), /*#__PURE__*/_react["default"].createElement("image", {
        x: seatX + 6 + "%",
        y: parseInt(this.props.player.cy - 4.5) + "%",
        width: "11%",
        height: "11%",
        href: baseUrl + backCard
      })) : null : null, /*#__PURE__*/_react["default"].createElement("image", {
        x: seatX + "%",
        y: parseInt(this.props.player.cy - 3) + "%",
        width: "15%",
        height: "15%",
        href: baseUrl + seat
      }), /*#__PURE__*/_react["default"].createElement("image", {
        x: this.props.player.cx + "%",
        y: this.props.player.cy + "%",
        width: "9%",
        height: "9%",
        href: baseUrl + playerOld
      }), this.props.player.status === "active" ? null : /*#__PURE__*/_react["default"].createElement("image", {
        x: this.props.player.cx + "%",
        y: this.props.player.cy + "%",
        width: "9%",
        height: "9%",
        href: baseUrl + foldPlayer
      }), /*#__PURE__*/_react["default"].createElement("image", {
        x: cashoutX + "%",
        y: cashoutY + "%",
        width: "5%",
        height: "9%",
        href: baseUrlForAll + cashout,
        style: {
          visibility: this.props.cashout_plyrs.findIndex(function (item) {
            return _this2.props.player.playerName === item.name;
          }) != -1 ? 'visible' : 'hidden'
        }
      }), /*#__PURE__*/_react["default"].createElement("text", {
        x: seatName + "%",
        y: parseInt(this.props.player.cy) + 3.5 + "%",
        fill: this.props.color
      }, this.props.playerName), /*#__PURE__*/_react["default"].createElement("text", {
        x: seatName + "%",
        y: parseInt(this.props.player.cy) + 7 + "%",
        fill: "yellow"
      }, (this.props.gameTypeForTitle === "tournament" ? "" : this.getCurrencySymbol(this.props.currency)) + this.props.player.startStack));
    }
  }]);
  return Seat;
}(_react.Component);
var _default = Seat;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReplayTable/Seat.js
 ** module id = 2384
 ** module chunks = 0
 **/